"use client"
import {Box, Flex, Grid, Text, Image, Title, UnstyledButton} from "@mantine/core";
import {COLORS, INFO_BLOCK_TYPES} from "src/constants";
import {AppealFeature} from "src/features/client";
import {useEffect, useRef, useState} from "react";
import { InfoBlock, searchInfoBlock} from "src/entities/info_block";
import { AttachmentPath} from "src/entities/attachments";
import {Content} from "src/shared/helpers/content";
import {Carousel} from "@mantine/carousel";
import Autoplay from 'embla-carousel-autoplay';
import {useTranslation} from "react-i18next";
import {Link} from "react-router-dom";
import {useMediaQuery} from "@mantine/hooks";

const defaultData: InfoBlock = {
    id: 1,
    type: INFO_BLOCK_TYPES.MAIN_PAGE,
    titleKg: "Курулуш материалдары жана тетиктери",
    titleRu: "Строительные материалы и комплектующие",
    contentKg: "Өнөр жай тажрыйбасы, реалдуу убакытта жаңыртууларды жана бүткүл дүйнө боюнча үзгүлтүксүз жеткирүү милдеттенмеси менен колдоого алынган ишенимдүү жеткирүү тажрыйбасын көрүңүз.",
    contentRu: "Воспользуйтесь надежной доставкой, подкрепленной отраслевым опытом, обновлениями в режиме реального времени для полной прозрачности и стремлением к бесперебойной доставке по всему миру, что позволит вам быть в курсе событий и уверенными на каждом этапе.",
}

export const WellcomeWidget = () => {
    const {i18n, t} = useTranslation();
    const locale = i18n.language
    const [data, setData] = useState<InfoBlock | undefined>(defaultData);
    const middleScreen = useMediaQuery("(max-width: 600px)");
    const fetchInfoBlock = async () => {
        const res = await searchInfoBlock({
            filter: {
                type: INFO_BLOCK_TYPES.MAIN_PAGE,
            },
            sorting: {sortBy: "ID", sortDirection: "DESC"},
            pageRequest: {limit: 1, page: 0}
        },false);
        setData(res?.content?.[0] || defaultData)
    }
    const autoplay = useRef(Autoplay({ delay: 5000 }));
    const filesUrls = [
        ...(data?.photoAttachments?.map(el => ({type: "image", url: AttachmentPath.GetAttachmentUrl(el.id)})) || []),
        ...(data?.videoAttachments?.map(el => ({type: "video", url: AttachmentPath.GetAttachmentUrl(el.id)})) || []),
    ];

    const getFileTag = (file: {type: string, url: string}) => {
        if(file.type === "image") {
            return (
                <Image
                    style={{objectFit: "cover" }}
                    width="100%"
                    height="100%"
                    src={file.url} alt="" />
            )
        }else if(file.type === "video") {
            return (
                <video
                    muted
                    autoPlay
                    loop
                    style={{objectFit: "cover"}}
                    width="100%"
                    height="100%"
                    src={file.url}
                />
            )
        }
    }

    const renderByFilesLength = () => {
        if (filesUrls?.length === 1) {
            const firstFile = filesUrls[0];
            return getFileTag(firstFile);
        } else if (filesUrls.length > 1) {
            return (
                <Carousel
                    withControls={false}
                    plugins={[autoplay.current]}
                    onMouseEnter={autoplay.current.stop}
                    onMouseLeave={autoplay.current.reset}
                    slideGap={24}
                    loop style={{minHeight: middleScreen ? "auto" : "400px"}}
                    align="center"
                    slideSize="100%"
                >
                    {filesUrls?.map((file) => (
                        <Carousel.Slide key={file.url} style={{ height: "100%" }}>
                            {getFileTag(file)}
                        </Carousel.Slide>
                    ))}
                </Carousel>
            );
        }
    };


    useEffect(() => {
        fetchInfoBlock()
    }, [])
    return (
        <Box pos="relative" style={{overflow: 'hidden'}}>
            <Box pos="absolute" style={{zIndex: 1}} right={0} top={0} left={0} bottom={0}>
                {renderByFilesLength()}
            </Box>
            <Box bg="rgba(25, 38, 129, 0.4)" pos="absolute" style={{zIndex: 2}} h="100%" w="100%" top={0} right={0} left={0}/>
            <Grid pt={{base: 40,sm: 80}}
                  pb={{base: 60, sm:    120}} pos="relative"
                  style={{zIndex:3}} className="container"
                  gutter={32} mb={{base: 40,sm: 80}} align="center">
                    <Grid.Col span={{base: 12, md: 6}}>
                        <Title lh={1.2} mb={24} c={COLORS.PRIMARY_COLOR} fz={{base: 32, sm: 64}} fw={600}>
                            {Content.GetTitleByLanguage(data,locale)?.split(("«"))[0]} <br/>
                            «{Content.GetTitleByLanguage(data,locale)?.split(("«"))[1]}
                        </Title>
                        <Text mb={{base: 24, sm: 48}} c="rgba(255,255,255,0.8)" fz={{base: 14,sm: 16}} fw={400}>
                            {Content.HtmlRenderFromLocale({
                                titleKg: data?.contentKg,
                                titleRu: data?.contentRu,
                            },locale)}
                        </Text>
                        <Flex gap={24}>
                            <UnstyledButton
                                component={Link}
                                to={`/${i18n.language || "ru"}/categories-list`}
                                bg={COLORS.PRIMARY_BG} style={{ borderRadius: "100px"}}
                                            px={24} py={14} fz={14} c={COLORS.PRIMARY_COLOR}>
                                {t("button.categories")}
                            </UnstyledButton>
                            <UnstyledButton
                                component={Link}
                                to={`/${i18n.language || "ru"}/contacts`}
                                bg="#FAFAFA" style={{ borderRadius: "100px"}}
                                            px={24} py={14} fz={14} c={COLORS.TRIOTERY_COLOR}>
                                {t("button.contacts")}
                            </UnstyledButton>
                        </Flex>
                    </Grid.Col>
                    <Grid.Col span={{base: 12, md: 6}}>
                        <Flex w="100%" justify={{base: "center", md: "end"}}>
                            <AppealFeature/>
                        </Flex>
                    </Grid.Col>
                </Grid>
        </Box>
    )
}